import { api } from '../utils/axiosInstance'
import { getApiHeaders } from './deviceRegistrationApi'
import { userAppApi } from '../utils/axiosInstance'
import { encryptPayload } from '../../../../apps/super-app/src/crypto/encryptPayload.js'

export async function getInviteAPI() {
  const headers = getApiHeaders()
  const response = await userAppApi({
    method: 'get',
    url: 'user/v1/device/device-invite-status',
    headers: {
      ...headers,
    }
  })
  return response?.data || response
}

export async function postCouponAPI({ deviceId, couponId }) {
  const headers = getApiHeaders()
  const encryptedData = await encryptPayload({ device_id: deviceId, coupon_id: couponId })
  const response = await userAppApi({
    method: 'post',
    url: 'user/v1/device/invite',
    data: encryptedData,
    headers: {
      ...headers,
    }
  })
  return response
}

export async function joinWaitList({
  deviceId,
  email,
  name,
  mobile,
  callingCode
}) {
  const headers = getApiHeaders()
  const payload = {
    device_id: deviceId,
    name: name,
  }

  if (mobile) {
    payload.mobile = mobile
    payload.calling_code = callingCode
  } else if (email) {
    payload.email = email
  }

  const encryptedData = await encryptPayload(payload)
  
  const response = await userAppApi({
    method: 'post',
    url: 'user/v1/social/waitlist',
    data: encryptedData,
    headers: {
      ...headers,
    }
  })
  return response
}

export async function verifyInviteOTP({
  email,
  otpValue,
  mobile,
  callingCode,
  isWaitList
}) {
  let intent
  
if (isWaitList) {
  intent = "waitlist"
} else if (email) {
  intent = "update_email"
} else {
  intent = "update_mobile"
}

  const headers = getApiHeaders()
  const payload = mobile ? {
    otp: otpValue,
    mobile: mobile,
    calling_code: callingCode,
    intent: intent
  } : {
    otp: otpValue,
    email: email,
    intent: intent
  }
 
  const encryptedData = await encryptPayload(payload)
  const response = await userAppApi({
    method: 'post',
    url: 'user/v1/social/waitlist_verify_otp',
    data: encryptedData,
    headers: {
      ...headers,
    }
  })
  return response
}

export async function resendOTP({ email, mobile, callingCode }) {
  const headers = getApiHeaders()
  const payload = {}
  if (email) {
    payload.email_id = email
  } else {
    payload.mobile = mobile
    payload.calling_code = callingCode
  }
  const encryptedData = await encryptPayload(payload)
  const response = await userAppApi({
    method: 'post',
    url: 'user/v1/social/waitlist_resend_otp',
    data: encryptedData,
    headers: {
      ...headers,
    }
  })
  return response
}

// export async function friendInviteList(emailList) {
//   const response = await api({
//     method: 'post',
//     url: 'v1/friend-invite/',
//     data: { invited_email_ids: emailList }
//   })
//   return response
// }

export async function friendInviteList(invitedList) {
  const headers = getApiHeaders()
  const response = await userAppApi({
    method: 'post',
    url: 'user/v1/social/friend_invite',
    data: {invited_list: invitedList} ,
    headers: {
      ...headers,
    }
  })
  return response
}
